[
  {
    "id": "mostUsed",
    "icons": [{ "id": "cross_black_thick_v1" }, { "id": "cross_thick_v1" }]
  },
  {
    "id": "01_gefahren",
    "icons": [
      {
        "id": "street_114_v1"
      },
      {
        "id": "street_115_v1"
      },
      {
        "id": "street_120_v1"
      },
      {
        "id": "street_158_v1"
      },
      {
        "id": "street_159_v1"
      },
      {
        "id": "street_160_v1"
      },
      {
        "id": "street_161_v1"
      },
      {
        "id": "street_162_v1"
      },
      {
        "id": "street_163_v1"
      },
      {
        "id": "street_164_v1"
      },
      {
        "id": "street_165_v1"
      },
      {
        "id": "street_166_v1"
      },
      {
        "id": "street_167_v1"
      },
      {
        "id": "street_168_v1"
      },
      {
        "id": "street_169_v1"
      },
      {
        "id": "street_170_v1"
      },
      {
        "id": "street_171_v1"
      },
      {
        "id": "street_172_v1"
      },
      {
        "id": "street_173_v1"
      },
      {
        "id": "street_174_v1"
      },
      {
        "id": "street_175_v1"
      },
      {
        "id": "street_176_v1"
      },
      {
        "id": "street_177_v1"
      },
      {
        "id": "street_178_v1"
      },
      {
        "id": "street_179_v1"
      },
      {
        "id": "street_180_v1"
      },
      {
        "id": "street_181_v1"
      },
      {
        "id": "street_182_v1"
      },
      {
        "id": "street_183_v1"
      },
      {
        "id": "street_184_v1"
      },
      {
        "id": "street_185_v1"
      }
    ]
  },
  {
    "id": "02_verbote",
    "icons": [
      {
        "id": "street_117_v1"
      },
      {
        "id": "street_121_v1"
      },
      {
        "id": "street_122_v1"
      },
      {
        "id": "street_123_v1"
      },
      {
        "id": "street_124_v1"
      },
      {
        "id": "street_125_v1"
      },
      {
        "id": "street_126_v1"
      },
      {
        "id": "street_127_v1"
      },
      {
        "id": "street_128_v1"
      },
      {
        "id": "street_129_v1"
      },
      {
        "id": "street_130_v1"
      },
      {
        "id": "street_131_v1"
      },
      {
        "id": "street_132_v1"
      },
      {
        "id": "street_133_v1"
      },
      {
        "id": "street_134_v1"
      },
      {
        "id": "street_135_v1"
      },
      {
        "id": "street_136_v1"
      },
      {
        "id": "street_137_v1"
      },
      {
        "id": "street_138_v1"
      },
      {
        "id": "street_139_v1"
      },
      {
        "id": "street_140_v1"
      },
      {
        "id": "street_141_v1"
      },
      {
        "id": "street_142_v1"
      },
      {
        "id": "street_143_v1"
      },
      {
        "id": "street_144_v1"
      },
      {
        "id": "street_145_v1"
      },
      {
        "id": "street_146_v1"
      },
      {
        "id": "street_147_v1"
      },
      {
        "id": "street_148_v1"
      },
      {
        "id": "street_149_v1"
      },
      {
        "id": "street_150_v1"
      },
      {
        "id": "street_151_v1"
      },
      {
        "id": "street_152_v1"
      },
      {
        "id": "street_153_v1"
      },
      {
        "id": "street_154_v1"
      },
      {
        "id": "street_155_v1"
      },
      {
        "id": "street_156_v1"
      },
      {
        "id": "street_157_v1"
      }
    ]
  },
  {
    "id": "haltekanten",
    "insertAfter": "01_Gleise",
    "icons": [
      {
        "id": "sbb_kante_A_de_v1"
      },
      {
        "id": "sbb_kante_A_fr_v1"
      },
      {
        "id": "sbb_kante_A_it_v1"
      },
      {
        "id": "sbb_kante_B_de_v1"
      },
      {
        "id": "sbb_kante_B_fr_v1"
      },
      {
        "id": "sbb_kante_B_it_v1"
      },
      {
        "id": "sbb_kante_C_de_v1"
      },
      {
        "id": "sbb_kante_C_fr_v1"
      },
      {
        "id": "sbb_kante_C_it_v1"
      },
      {
        "id": "sbb_kante_D_de_v1"
      },
      {
        "id": "sbb_kante_D_fr_v1"
      },
      {
        "id": "sbb_kante_D_it_v1"
      },
      {
        "id": "sbb_kante_E_de_v1"
      },
      {
        "id": "sbb_kante_E_fr_v1"
      },
      {
        "id": "sbb_kante_E_it_v1"
      },
      {
        "id": "sbb_kante_F_de_v1"
      },
      {
        "id": "sbb_kante_F_fr_v1"
      },
      {
        "id": "sbb_kante_F_it_v1"
      },
      {
        "id": "sbb_kante_G_de_v1"
      },
      {
        "id": "sbb_kante_G_fr_v1"
      },
      {
        "id": "sbb_kante_G_it_v1"
      },
      {
        "id": "sbb_kante_H_de_v1"
      },
      {
        "id": "sbb_kante_H_fr_v1"
      },
      {
        "id": "sbb_kante_H_it_v1"
      },
      {
        "id": "sbb_kante_I_de_v1"
      },
      {
        "id": "sbb_kante_I_fr_v1"
      },
      {
        "id": "sbb_kante_I_it_v1"
      },
      {
        "id": "sbb_kante_J_de_v1"
      },
      {
        "id": "sbb_kante_J_fr_v1"
      },
      {
        "id": "sbb_kante_J_it_v1"
      },
      {
        "id": "sbb_kante_K_de_v1"
      },
      {
        "id": "sbb_kante_K_fr_v1"
      },
      {
        "id": "sbb_kante_K_it_v1"
      },
      {
        "id": "sbb_kante_L_de_v1"
      },
      {
        "id": "sbb_kante_L_fr_v1"
      },
      {
        "id": "sbb_kante_L_it_v1"
      },
      {
        "id": "sbb_kante_M_de_v1"
      },
      {
        "id": "sbb_kante_M_fr_v1"
      },
      {
        "id": "sbb_kante_M_it_v1"
      },
      {
        "id": "sbb_kante_N_de_v1"
      },
      {
        "id": "sbb_kante_N_fr_v1"
      },
      {
        "id": "sbb_kante_N_it_v1"
      },
      {
        "id": "sbb_kante_O_de_v1"
      },
      {
        "id": "sbb_kante_O_fr_v1"
      },
      {
        "id": "sbb_kante_O_it_v1"
      },
      {
        "id": "sbb_kante_P_de_v1"
      },
      {
        "id": "sbb_kante_P_fr_v1"
      },
      {
        "id": "sbb_kante_P_it_v1"
      },
      {
        "id": "sbb_kante_Q_de_v1"
      },
      {
        "id": "sbb_kante_Q_fr_v1"
      },
      {
        "id": "sbb_kante_Q_it_v1"
      },
      {
        "id": "sbb_kante_R_de_v1"
      },
      {
        "id": "sbb_kante_R_fr_v1"
      },
      {
        "id": "sbb_kante_R_it_v1"
      },
      {
        "id": "sbb_kante_S_de_v1"
      },
      {
        "id": "sbb_kante_S_fr_v1"
      },
      {
        "id": "sbb_kante_S_it_v1"
      },
      {
        "id": "sbb_kante_T_de_v1"
      },
      {
        "id": "sbb_kante_T_fr_v1"
      },
      {
        "id": "sbb_kante_T_it_v1"
      },
      {
        "id": "sbb_kante_U_de_v1"
      },
      {
        "id": "sbb_kante_U_fr_v1"
      },
      {
        "id": "sbb_kante_U_it_v1"
      },
      {
        "id": "sbb_kante_V_de_v1"
      },
      {
        "id": "sbb_kante_V_fr_v1"
      },
      {
        "id": "sbb_kante_V_it_v1"
      },
      {
        "id": "sbb_kante_W_de_v1"
      },
      {
        "id": "sbb_kante_W_fr_v1"
      },
      {
        "id": "sbb_kante_W_it_v1"
      },
      {
        "id": "sbb_kante_X_de_v1"
      },
      {
        "id": "sbb_kante_X_fr_v1"
      },
      {
        "id": "sbb_kante_X_it_v1"
      },
      {
        "id": "sbb_kante_Y_de_v1"
      },
      {
        "id": "sbb_kante_Y_fr_v1"
      },
      {
        "id": "sbb_kante_Y_it_v1"
      },
      {
        "id": "sbb_kante_Z_de_v1"
      },
      {
        "id": "sbb_kante_Z_fr_v1"
      },
      {
        "id": "sbb_kante_Z_it_v1"
      }
    ]
  },
  {
    "id": "02_Parkieren",
    "icons": [
      {
        "id": "E-Velo-Ladestation_r_v1"
      },
      {
        "id": "E-Auto-Ladestation_r_v1"
      }
    ]
  },
  {
    "id": "03_gebote",
    "icons": [
      {
        "id": "street_001_v1"
      },
      {
        "id": "street_002_v1"
      },
      {
        "id": "street_003_v1"
      },
      {
        "id": "street_004_v1"
      },
      {
        "id": "street_005_v1"
      },
      {
        "id": "street_006_v1"
      },
      {
        "id": "street_007_v1"
      },
      {
        "id": "street_008_v1"
      },
      {
        "id": "street_009_v1"
      },
      {
        "id": "street_010_v1"
      },
      {
        "id": "street_011_v1"
      },
      {
        "id": "street_012_v1"
      },
      {
        "id": "street_013_v1"
      },
      {
        "id": "street_014_v1"
      },
      {
        "id": "street_015_v1"
      },
      {
        "id": "street_016_v1"
      },
      {
        "id": "street_017_v1"
      },
      {
        "id": "street_018_v1"
      },
      {
        "id": "street_019_v1"
      },
      {
        "id": "street_020_v1"
      },
      {
        "id": "street_021_v1"
      },
      {
        "id": "street_022_v1"
      },
      {
        "id": "street_076_v1"
      },
      {
        "id": "street_077_v1"
      },
      {
        "id": "street_078_v1"
      },
      {
        "id": "street_079_v1"
      },
      {
        "id": "street_080_v1"
      },
      {
        "id": "street_081_v1"
      },
      {
        "id": "street_082_v1"
      },
      {
        "id": "street_083_v1"
      },
      {
        "id": "street_084_v1"
      },
      {
        "id": "street_085_v1"
      },
      {
        "id": "street_086_v1"
      },
      {
        "id": "street_087_v1"
      },
      {
        "id": "street_088_v1"
      },
      {
        "id": "street_089_v1"
      },
      {
        "id": "street_090_v1"
      },
      {
        "id": "street_091_v1"
      },
      {
        "id": "street_092_v1"
      },
      {
        "id": "street_093_v1"
      },
      {
        "id": "street_094_v1"
      },
      {
        "id": "street_095_v1"
      },
      {
        "id": "street_096_v1"
      },
      {
        "id": "street_097_v1"
      },
      {
        "id": "street_098_v1"
      },
      {
        "id": "street_099_v1"
      },
      {
        "id": "street_100_v1"
      },
      {
        "id": "street_101_v1"
      },
      {
        "id": "street_102_v1"
      },
      {
        "id": "street_103_v1"
      },
      {
        "id": "street_104_v1"
      },
      {
        "id": "street_105_v1"
      },
      {
        "id": "street_106_v1"
      },
      {
        "id": "street_107_v1"
      },
      {
        "id": "street_116_v1"
      }
    ]
  },
  {
    "id": "04_Dienstleistungen",
    "icons": [
      {
        "id": "entwerter_cj_v1"
      }
    ]
  },
  {
    "id": "04_rest",
    "icons": [
      {
        "id": "street_023_v1"
      },
      {
        "id": "street_024_v1"
      },
      {
        "id": "street_025_v1"
      },
      {
        "id": "street_026_v1"
      },
      {
        "id": "street_027_v1"
      },
      {
        "id": "street_028_v1"
      },
      {
        "id": "street_029_v1"
      },
      {
        "id": "street_030_v1"
      },
      {
        "id": "street_031_v1"
      },
      {
        "id": "street_032_v1"
      },
      {
        "id": "street_033_v1"
      },
      {
        "id": "street_034_v1"
      },
      {
        "id": "street_035_v1"
      },
      {
        "id": "street_036_v1"
      },
      {
        "id": "street_037_v1"
      },
      {
        "id": "street_038_v1"
      },
      {
        "id": "street_039_v1"
      },
      {
        "id": "street_040_v1"
      },
      {
        "id": "street_041_v1"
      },
      {
        "id": "street_042_v1"
      },
      {
        "id": "street_043_v1"
      },
      {
        "id": "street_044_v1"
      },
      {
        "id": "street_045_v1"
      },
      {
        "id": "street_046_v1"
      },
      {
        "id": "street_047_v1"
      },
      {
        "id": "street_048_v1"
      },
      {
        "id": "street_049_v1"
      },
      {
        "id": "street_050_v1"
      },
      {
        "id": "street_051_v1"
      },
      {
        "id": "street_052_v1"
      },
      {
        "id": "street_053_v1"
      },
      {
        "id": "street_054_v1"
      },
      {
        "id": "street_055_v1"
      },
      {
        "id": "street_056_v1"
      },
      {
        "id": "street_057_v1"
      },
      {
        "id": "street_058_v1"
      },
      {
        "id": "street_059_v1"
      },
      {
        "id": "street_060_v1"
      },
      {
        "id": "street_061_v1"
      },
      {
        "id": "street_061_alt_v1"
      },
      {
        "id": "street_062_v1"
      },
      {
        "id": "street_063_v1"
      },
      {
        "id": "street_064_v1"
      },
      {
        "id": "street_065_v1"
      },
      {
        "id": "street_066_v1"
      },
      {
        "id": "street_067_v1"
      },
      {
        "id": "street_068_v1"
      },
      {
        "id": "street_069_v1"
      },
      {
        "id": "street_070_v1"
      },
      {
        "id": "street_071_v1"
      },
      {
        "id": "street_072_v1"
      },
      {
        "id": "street_073_v1"
      },
      {
        "id": "street_074_v1"
      },
      {
        "id": "street_075_v1"
      },
      {
        "id": "street_108_v1"
      },
      {
        "id": "street_109_v1"
      },
      {
        "id": "street_110_v1"
      },
      {
        "id": "street_111_v1"
      },
      {
        "id": "street_112_v1"
      },
      {
        "id": "street_113_v1"
      },
      {
        "id": "street_118_v1"
      },
      {
        "id": "street_119_v1"
      }
    ]
  },
  {
    "id": "03_Barrierefreiheit",
    "icons": [
      {
        "id": "handicap_v1"
      }
    ]
  }
]
